import { Button, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import StudioIcon from 'assets/icons/StudioIcon';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { locations } from 'services/routes/locations';
import useAnalytics from 'services/hooks/analytics/useAnalytics';
import { events } from 'services/analytics';
import StudioButtonIcon from '../StudioButtonIcon';
import { ButtonText } from './styled';

type Props = {
  songId: string;
  title: string;
  isAIGenerated: boolean;
  location: AnalyticsEventLocation;
};

const StudioButton = ({ songId, title, isAIGenerated, location }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { track } = useAnalytics();

  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const sendAnalyticsEvent = () => track(events.studioButtonClick(location));
  return (
    <>
      {isMobile ? (
        <StudioButtonIcon
          songId={songId}
          title={title}
          isAIGenerated
          location={location}
        />
      ) : (
        <Button
          component={RouterLink}
          to={locations.studio.song.pathname(songId, title, isAIGenerated)}
          onClick={sendAnalyticsEvent}
          variant="outlined"
          startIcon={<StudioIcon />}
        >
          <ButtonText>{t('customization:studio')}</ButtonText>
        </Button>
      )}
    </>
  );
};

export default StudioButton;
